'use client';

import type { Ref } from 'react';
import { motion, type SVGMotionProps } from 'motion/react';
import { Icon, type IconProps } from '@cbhq/bds-web/components/icon';

export type SpinnerProps = Omit<IconProps, 'ref'> & {
  ref?: Ref<SVGSVGElement | null>;
  strokeWidth?: number;
};

export function Spinner({ strokeWidth = 3.5, ...props }: SpinnerProps) {
  const r = 10.5;

  return (
    <Icon
      viewBox="0 0 40 40"
      strokeWidth={strokeWidth}
      render={(svgProps) => (
        <motion.svg
          animate={{ rotate: 360 }}
          transition={{ duration: 1, repeat: Infinity, ease: 'linear' }}
          {...(svgProps as SVGMotionProps<SVGSVGElement>)}
        />
      )}
      {...props}
    >
      <circle cx={20} cy={20} r={r} stroke="currentColor" strokeOpacity={0.25} />
      <path
        d={`M${20 + r} 20a${r} ${r} 0 0 0-${r}-${r}`}
        stroke="currentColor"
        strokeLinecap="round"
      />
    </Icon>
  );
}
